import { createSelector } from 'reselect';
import { FREE_SHIPPING_PROGRESS_BAR_ATB } from 'constants/TestTarget';
import { experienceSelector } from 'selectors/testTarget/offers/freeShippingProgressBarAtb/experience/experienceSelector';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';

/**
 * ViewModel selector for the Free Shipping Progress Bar ATB experiment.
 * Gates the variant flags behind `isTestTargetReadySelector` to avoid
 * flicker/hydration mismatch.
 *
 * @param {object} state Redux state.
 * @returns {{challengerOne: boolean, challengerTwo: boolean}}
 */
const activeFreeShippingProgressBarAtbSelector = createSelector(isTestTargetReadySelector, experienceSelector, (testReady, experience) => ({
    challengerOne: testReady && experience === FREE_SHIPPING_PROGRESS_BAR_ATB.CHALLENGER_ONE,
    challengerTwo: testReady && experience === FREE_SHIPPING_PROGRESS_BAR_ATB.CHALLENGER_TWO
}));

export { activeFreeShippingProgressBarAtbSelector };
